<template>
  <div class="uni-detail__wrp">
    <subpage-header :city-icon="universityDetails ? universityDetails.icon : null">
<div slot="bread">
<ul itemscope itemtype="http://schema.org/BreadcrumbList">
<!-- <li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="/" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span class="mytitle"> / </span>
<span itemprop="name">holywoodskyline.com</span>
</a>
<meta itemprop="position" content="1" />
</li>
<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a :href="universityDetails.slug" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name">{{ universityDetails.name}} Movies</span>
</a>
<meta itemprop="position" content="2" />
</li> -->

<li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="/" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name"></span>holywoodskyline.com<span class="mytitle"> / </span>
</a>
<meta itemprop="position" content="1" />
</li>
<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a :href="uni_url" class="" itemtype="https://schema.org/Thing" itemprop="item">
&nbsp;<span itemprop="name">{{ uni_name }} Movies</span>
</a>
<meta itemprop="position" content="2" />
</li>

</ul>

</div>      
      <span slot="title" v-if="universityDetails">
        <span class="color-light-green">{{ universityDetails.name }} </span> About
      </span>
      <div class="city-text" slot="text">
        <span v-if="universityDetails" v-html="universityDetails.detail_spot"></span>
      </div>
<!--       <div class="subpage-header-inf" slot="numbers">
        <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-dorm-female.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="universityDetails">{{ universityDetails.universities_count }}</strong>
            <span>Kız Öğr. Yurdu</span>
          </div>
        </div>

        <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-dorm-male.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="universityDetails">{{ universityDetails.dorms_count }}</strong>
            <span>Erkek Öğr. Yurdu</span>
          </div>
        </div>
      </div> -->
      <v-link
        v-if="universityDetails"
        class="button--more color-white subpage-header__btn"
        :title="`${universityDetails.name} Movies`"
        icon="icon-arrow-long-right"
        icon-position="right"
        :to="{ name: 'University', params: { slug: universityDetails.slug }}"
        slot="button"
      />

      <div class="uni-detail__card" slot="right" v-if="universityDetails">
        <UniInfoCard
          :logo="universityDetails.logo"
          :website="universityDetails.website"
        />
      </div>
    </subpage-header>
    <div class="subpage__inner uni-detail__inner">
      <SubpageNav :links="links" class="DesktopTab" />
      <div class="mobileTab">
        <!-- <select-box :options="linkMobile" title="Girişimcilik"/> -->
        <v-select placeholder="Hakkında" :options="linkMobile" @onselect="selectCategory"/>        
      </div>   
      <transition name="fade-up">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import SubpageHeader from '@/components/SubpageHeader'
import SubpageNav from '@/components/SubpageNav'
import UniInfoCard from '@/components/UniInfoCard'
import axios from 'axios'
import { mapGetters } from 'vuex'
import {
  GET_UNIVERSITY_DETAILS
} from '@/store/actions.type'
export default {
  name: 'UniDetail',
  components: {
    SubpageHeader, SubpageNav, UniInfoCard
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.universityDetails ? this.universityDetails.detail_title : '',
      meta: [
        { name: 'description', content: this.universityDetails ? this.universityDetails.detail_description : '' },
        { name: 'keywords', content: this.universityDetails ? this.universityDetails.detail_keywords : '' }
      ],
      link: [
        { rel: 'canonical', href: this.url }
      ]       
    }
  },
  data () {
    return {
      fullPath: '',
      url: '',
      uni_url: '',
      uni_name: '',
      myslug: null,
      selectedTab: {
        name: 'About',
        slug: '/hakkinda'
      },
      links: [
        {
          id: 0,
          title: 'About',
          to: { name: 'UniDetailAbout', params: { id: this.$route.params.id, slug: this.$route.params.slug } }
        },
        {
          id: 1,
          title: 'Genres',
          to: { name: 'UniDetailFaculty' }
        }
/*         {
          id: 2,
          title: 'Kampüste Yaşam',
          to: { name: 'UniDetailCampus' }
        },
        {
          id: 3,
          title: 'Soru Cevap',
          to: { name: 'UniQuestionsAnswer' }
        } */
      ],
      linkMobile: [
        {
          name: 'About'
        },
        {
          name: 'Genres'
        }/* ,
        {
          name: 'Kampüste Yaşam'
        },
        {
          name: 'Soru-Cevap'
        } */
      ]
    }
  },
  methods: {
    selectCategory(opt) {
      if(opt.name === 'Fakülteler') {
        this.$router.push('fakulteler')
      } else {
          this.$router.push({name: 'UniDetailAbout', params: { id: this.$route.params.id, slug: this.$route.params.slug }})
      }
    },     
    checkTab () {
      let slug = this.$route.params.slug.split('/')
      if(this.$route.path.includes('fakulteler')) {
        this.selectedTab.name = 'Fakülteler'
        this.selectedTab.slug = slug[0] + slug [1] + '/fakulteler'
      } /* else if(this.$route.path.includes('kampus')) {
        this.selectedTab.name = 'Kampüste Yaşam'
        this.selectedTab.slug = slug[0] + slug [1] + '/kampus'
      } else if(this.$route.path.includes('soru-cevap')) {
        this.selectedTab.name = 'Soru Cevap'
        this.selectedTab.slug = slug[0] + slug [1] + '/soru-cevap'
      } */ else {
        this.selectedTab.name = 'About'
        this.selectedTab.slug = slug[0] + slug [1] + '/fakulteler'
      }
    },
    checkUniDetails () {
      const slug = this.$route.params.slug
      // console.log(slug)
      if (this.universityDetails) {
        if (this.universityDetails.slug !== slug) {
          this.$store.dispatch(GET_UNIVERSITY_DETAILS, null)
          this.getUniDetails()
        }
      } else {
        this.getUniDetails()
      }
    },
    getUniDetails () {
      let self = this
      axios.get(`/site/universities/detail/${self.$route.params.slug}`)
        .then(response => {
          self.$store.dispatch(GET_UNIVERSITY_DETAILS, response.data)
          self.uni_url = '/' + response.data.slug + '-yakin-ogrenci-yurtlari/'
          self.uni_name = response.data.name
        })
        .catch(e => {
          self.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['universityDetails'])
  },
  mounted () {
    //this.checkUniDetails()
    this.getUniDetails()
  },  
  created () {
    this.checkUniDetails()
    this.getUniDetails()
    this.url = window.location.origin + this.$route.fullPath
      let slug = this.$route.params.slug.split('/')
    this.fullPath = this.$route.fullPath
    //  this.myslug = slug + '-hakkinda' //.replace('fakulteler','')
    //  if(this.$route.path.includes('fakulteler')) {
       // this.selectedTab.name = 'Fakülteler'
       //this.myslug = slug[0]
   //   }    
   // this.myslug =  this.$route.params.slug
/*          if(this.$route.path.includes('fakulteler')) {
      let slug = this.$route.params.slug.split('/')
      this.myslug = slug[0] + slug[1]
         } */
  },
  watch: {
    $route () {
      this.checkTab()
      this.checkUniDetails()
/*       if(this.$route.path.includes('fakulteler')) {
      let slug = this.$route.params.slug.split('/')
      this.myslug = slug[0] + slug[1]
     // this.myslug = slug + '-hakkinda'      
    } */
  }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/components/uni-detail";
  .mytitle {
    font-size: 15px;
    color:white;
  }
</style>
